import { createElement, Fragment, useMemo } from "react";
import { FormProvider } from "react-hook-form";
import { Option } from "space-monad";
import { basicFields } from "../../../store/launch-configurations/models/basic-fields";
import { useDefaultFieldMap } from "../../../store/launch-configurations/models/default-fields";
import { LaunchConfigurationsDTO } from "../../../store/launch-configurations/models/dto";
import { Field } from "../../../store/launch-configurations/models/internal/field";
import DefaultPage from "./pages/default";
import { useDataInRedux } from "./persistant-form-storage";
import { useStepForm } from "./step/step-form.hook";

export type PageProps<T extends string> = {
  item: LaunchConfigurationsDTO.Responses.GetSingle.T;
  fields: Array<Field.Field<T>>;
  index: number;
  isLast: boolean;
  setError?: (error: Option<Error>) => void;
  allFields: Array<Field.Field<string>>;
};

export const Page = ({
  item,
  fields,
  isLast,
  setError,
  allFields,
}: PageProps<string>) => {
  const { persistInStorage, data } = useDataInRedux<any>(item);
  const defaultFieldMap = useDefaultFieldMap();
  const form = useStepForm({
    item,
    fields,
    isLast,
    defaultValues: data,
    persistInStorage,
    setError,
    allFields,
  });

  const renderedFields = useMemo(
    () =>
      fields.map((f) => {
        return (
          <Fragment key={f.field}>
            {Field.isDefaultField(f)
              ? createElement(defaultFieldMap[f.field].elem, {
                  item: f,
                })
              : createElement(basicFields[f.type], { item: f })}
          </Fragment>
        );
      }),
    [fields, defaultFieldMap]
  );

  return (
    <FormProvider {...form}>
      {createElement(DefaultPage, { item }, renderedFields)}
    </FormProvider>
  );
};
